// extracted by mini-css-extract-plugin
module.exports = {"courseEditPage":"CourseEditPage_courseEditPage__2qwq4","block":"CourseEditPage_block__gd0Pq"};